import bc1 from '../assets/thumbnails/bc1.png';
import bc2 from '../assets/thumbnails/bc2.png';
import bc3 from '../assets/thumbnails/bc3.png';
import bc4 from '../assets/thumbnails/bc4.png';
import bc5 from '../assets/thumbnails/bc5.png';
import bc6 from '../assets/thumbnails/bc6.png';
import bc7 from '../assets/thumbnails/bc7.png';
import bc8 from '../assets/thumbnails/bc8.png';
import bc9 from '../assets/thumbnails/bc9.png';
import bc10 from '../assets/thumbnails/bc10.png';
import bc11 from '../assets/thumbnails/bc11.png';
import bc12 from '../assets/thumbnails/bc12.png';
import bc13 from '../assets/thumbnails/bc13.png';
import bc14 from '../assets/thumbnails/bc14.png';
import bc15 from '../assets/thumbnails/bc15.png';
import bc16 from '../assets/thumbnails/bc16.png';
import bc17 from '../assets/thumbnails/bc17.png';
import bc18 from '../assets/thumbnails/bc18.png';
import bc19 from '../assets/thumbnails/bc19.png';
import bc20 from '../assets/thumbnails/bc20.png';
import bc21 from '../assets/thumbnails/bc21.png';
import bc22 from '../assets/thumbnails/bc22.png';
import bc23 from '../assets/thumbnails/bc23.png';
import bc24 from '../assets/thumbnails/bc24.png';
import bc25 from '../assets/thumbnails/bc25.png';
import bc26 from '../assets/thumbnails/bc26.png';
import bc27 from '../assets/thumbnails/bc27.png';
import bc28 from '../assets/thumbnails/bc28.png';
import bc29 from '../assets/thumbnails/bc29.png';
import bc30 from '../assets/thumbnails/bc30.png';
import bc31 from '../assets/thumbnails/bc31.png';
import bc32 from '../assets/thumbnails/bc32.png';
import bc33 from '../assets/thumbnails/bc33.png';
import bc34 from '../assets/thumbnails/bc34.png';
import bc35 from '../assets/thumbnails/bc35.png';
import bc36 from '../assets/thumbnails/bc36.png';
import bc37 from '../assets/thumbnails/bc37.png';
import bc38 from '../assets/thumbnails/bc38.png';
import bc39 from '../assets/thumbnails/bc39.png';
import bc40 from '../assets/thumbnails/bc40.png';
import bc41 from '../assets/thumbnails/bc41.png';
import bc42 from '../assets/thumbnails/bc42.png';
import bc43 from '../assets/thumbnails/bc43.png';
import bc44 from '../assets/thumbnails/bc44.png';
import bc45 from '../assets/thumbnails/bc45.png';
import bc46 from '../assets/thumbnails/bc46.png';
import bc47 from '../assets/thumbnails/bc47.png';
import bc48 from '../assets/thumbnails/bc48.png';
import bc49 from '../assets/thumbnails/bc49.png';
import bc50 from '../assets/thumbnails/bc50.png';
import bc51 from '../assets/thumbnails/bc51.png';
import bc52 from '../assets/thumbnails/bc52.png';
import bc53 from '../assets/thumbnails/bc53.gif';
import bc54 from '../assets/thumbnails/bc54.png';
import bc55 from '../assets/thumbnails/bc55.png';
import bc56 from '../assets/thumbnails/bc56.png';
import bc57 from '../assets/thumbnails/bc57.png';


import Designchip from '../components/Chips/Designchip';
import Devchip from '../components/Chips/Devchip';

import FigmaLogo from '../components/Chips/FigmaLogo';
import Firebase from '../components/Chips/Firebase';
import Illustrator from '../components/Chips/Illustrator';
import Javascript from '../components/Chips/Javascript';
import Mongodb from '../components/Chips/Mongodb';
import Redux from '../components/Chips/Redux';
import Rjs from '../components/Chips/Rjs';
import PalleteLogo from '../components/Chips/PalleteLogo';
import React from 'react';




const blogData = [
    {
    id: 57,
    title: "Bloome Web Page",
    date: "Nov 2025",
    image: bc57,
    link: "https://dhanushgopi.github.io/bloomelandingpage/",
    category: "dev",
    stack:[<FigmaLogo/>,<Rjs/>],
    chip: <Devchip/>,
    },
    {
    id: 56,
    title: "Bloome Cosmetic UI",
    date: "Nov 2025",
    image: bc56,
    link: "https://www.figma.com/design/wNn99A4mMPJoN3MEyQrQaw/Dezinersknot?node-id=0-1&t=nqM4J0nDXo0txCIA-1",
    category: "ux",
    stack:[<FigmaLogo/>],
    chip: <Designchip/>,
    },
    {
    id: 55,
    title: "I'm Notcute",
    date: "Nov 2025",
    image: bc55,
    link: "https://www.instagram.com/p/DRNQMBTkyli/?utm_source=ig_web_button_share_sheet&igsh=MzRlODBiNWFlZA==",
    category: "illustration",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 54,
    title: "EV Station Finder",
    date: "Oct 2025",
    image: bc54,
    link: "https://www.behance.net/gallery/236995335/EV-Bike-Charging-Station-Finder-and-Charging-Screen",
    category: "ux",
    stack:[<FigmaLogo/>],
    chip: <Designchip/>,
    },
    {
    id: 53,
    title: "Starry Night Pixel",
    date: "Oct 2025",
    image: bc53,
    link: "https://www.instagram.com/p/DPk7tQmk9UW/?utm_source=ig_web_button_share_sheet&igsh=MzRlODBiNWFlZA==",
    category: "illustration",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 1,
    title: "Rethinking ATVM UX",
    date: "Sep 2025",
    image: bc1,
    link: "https://www.behance.net/gallery/235444223/Rethinking-the-UX-of-Indian-Railways-ATVM",
    category: "ux",
    stack:[<FigmaLogo/>],
    chip: <Designchip/>,
    },
     {
    id: 2,
    title: "CCPO System UX",
    date: "Aug 2025",
    image: bc2,
    link: "https://www.behance.net/gallery/232126955/Campus-Cafeteria-Pre-Order-System-UX-Case-Study",
    category: "ux",
    stack:[<FigmaLogo/>],
    chip: <Designchip/>,
    },
     {
    id: 3,
    title: "Spider Man Painted",
    date: "Aug 2025",
    image: bc3,
    link: "https://www.instagram.com/p/DNLOPXZTvSC/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    category: "illustration",
    stack:[<PalleteLogo/>],
    chip: <Designchip/>,
    },
    {
    id: 4,
    title: "Iron Moai",
    date: "Jul 2025",
    image: bc4,
    link: "https://www.instagram.com/p/DMvlDDETyuE/?utm_source=ig_web_button_share_sheet&igsh=MzRlODBiNWFlZA==",
    category: "illustration",
    stack:[<PalleteLogo/>,<FigmaLogo/>],
    chip: <Designchip/>,
    },
    {
    id: 5,
    title: "Greenbite UI",
    date: "Jun 2025",
    image: bc5,
    link: "https://www.behance.net/gallery/228151639/GREENBITE-UI-DESIGN",
    category: "ux",
    stack:[<FigmaLogo/>],
    chip: <Designchip/>,
    },
     {
    id: 6,
    title: "Sheildify UI",
    date: "May 2025",
    image: bc6,
    link: "https://www.figma.com/design/CHkmomFNhhFh8rSo1VRbuH/Shieldify?node-id=2-2&t=ZL9bSDJY8XcnkpxJ-1",
    category: "ux",
    stack:[<FigmaLogo/>],
    chip: <Designchip/>,
    },
    {
    id: 7,
    title: "Newre SaaS App",
    date: "Mar 2025",
    image: bc7,
    link: "https://newrev2.onrender.com/",
    category: "dev",
    stack:[<Rjs/>,<Firebase/>],
    chip: <Devchip/>,
    },
    {
    id: 8,
    title: "DPay",
    date: "Feb 2025",
    image: bc8,
    link: "https://nfcbc.onrender.com/",
    category: "dev",
    stack:[<Rjs/>],
    chip: <Devchip/>,
    },
    {
    id: 9,
    title: "Universoul",
    date: "Feb 2025",
    image: bc9,
    link: "https://www.instagram.com/p/DGiE6nczJBG/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    category: "illustration",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
     {
    id: 10,
    title: "BounceBack",
    date: "Jan 2025",
    image: bc10,
    link: "https://bounceback.onrender.com/",
    category: "dev",
    stack:[<Rjs/>],
    chip: <Devchip/>,
    },
    {
    id: 11,
    title: "Batman Pixart",
    date: "Dec 2024",
    image: bc11,
    link: "https://www.instagram.com/p/DEMP9F5TjnB/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    category: "illustration",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 12,
    title: "Bounce Back UX",
    date: "Dec 2024",
    image: bc12,
    link: "https://www.behance.net/gallery/235639629/BounceBack-SaaS-App-for-Physiotherapist",
    category: "ux",
    stack:[<FigmaLogo/>],
    chip: <Designchip/>,
    },
    {
    id: 13,
    title: "DesignFest24 UI",
    date: "Dec 2024",
    image: bc13,
    link: "https://www.behance.net/gallery/228636333/DesignFest-2024-UX-Challenge",
    category: "ux",
    stack:[<FigmaLogo/>],
    chip: <Designchip/>,
    },
     {
    id: 14,
    title: "Flamingo",
    date: "Nov 2024",
    image: bc14,
    link: "https://www.instagram.com/p/DCG9bBgTZxa/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    category: "illustration",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
     {
    id: 15,
    title: "Design of Diwali",
    date: "Oct 2024",
    image: bc15,
    link: "https://www.instagram.com/p/DByQufUTpoe/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    category: "illustration",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 16,
    title: "Good Vibe",
    date: "Oct 2024",
    image: bc16,
    link: "https://www.instagram.com/p/DBDTIfUTcJD/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    category: "illustration",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 17,
    title: "Lost in Mind",
    date: "Oct 2024",
    image: bc17,
    link: "https://www.instagram.com/p/DBDRsART894/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    category: "illustration",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 18,
    title: "Kanam App",
    date: "Sep 2024",
    image: bc18,
    link: "https://dhanushgopi.github.io/kanam",
    category: "dev",
    stack:[<Rjs/>,<Redux/>,<Mongodb/>],
    chip: <Devchip/>,
    },
    {
    id: 19,
    title: "ToDo App",
    date: "Sep 2024",
    image: bc19,
    link: "https://noteapp-t2w6.onrender.com/",
    category: "dev",
    stack:[<Rjs/>,<Mongodb/>],
    chip: <Devchip/>,
    },
     {
    id: 20,
    title: "Be You!",
    date: "Aug 2024",
    image: bc20,
    link: "https://www.instagram.com/p/C_C7tVUTNql/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    category: "illustration",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 21,
    title: "Love Light",
    date: "Aug 2024",
    image: bc21,
    link: "https://www.instagram.com/p/C-nkH0zz5pk/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    category: "illustration",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 22,
    title: "Sketch Book",
    date: "Aug 2024",
    image: bc22,
    link: "https://dhanushgopi.github.io/sketchbook/",
    category: "dev",
    stack:[<FigmaLogo/>,<Javascript/>],
    chip: <Devchip/>,
    },
    {
    id: 23,
    title: "Stunned Man",
    date: "Aug 2024",
    image: bc23,
    link: "https://www.instagram.com/p/C-iKT3XT6Wa/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    category: "illustration",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 24,
    title: "Read Automation",
    date: "Jun 2024",
    image: bc24,
    link: "https://danzustudio.github.io/read.html",
    category: "branddesign",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 25,
    title: "Aidit",
    date: "Jun 2024",
    image: bc25,
    link: "https://www.instagram.com/p/C8pFOlfveSy/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    category: "branddesign",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 26,
    title: "Daily Design",
    date: "Jun 2024",
    image: bc26,
    link: "https://www.instagram.com/p/C9SDZzKgSiA/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    category: "branddesign",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 27,
    title: "DANZU",
    date: "May 2024",
    image: bc27,
    link: "http://danzustudio.github.io/",
    category: "dev",
    stack:[<Illustrator/>,<FigmaLogo/>,<Javascript/>],
    chip: <Devchip/>,
    },
    {
    id: 28,
    title: "KGAS",
    date: "May 2024",
    image: bc28,
    link: "https://www.instagram.com/p/C6ZWoo5Pwsq/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    category: "branddesign",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 29,
    title: "Pastport",
    date: "Mar 2024",
    image: bc29,
    link: "https://www.behance.net/gallery/212707573/pastport-UIUX-Case-Study",
    category: "ux",
    stack:[<FigmaLogo/>],
    chip: <Designchip/>,
    },
    {
    id: 30,
    title: "Poverty Logo",
    date: "Feb 2024",
    image: bc30,
    link: "https://www.instagram.com/p/C55FuK4p4qJ/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    category: "branddesign",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
     {
    id: 31,
    title: "Why Vanmam!",
    date: "Nov 2023",
    image: bc31,
    link: "https://www.behance.net/gallery/226781883/danzu-typography",
    category: "typo",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
     {
    id: 32,
    title: "Under Survillance",
    date: "Sep 2023",
    image: bc32,
    link: "https://www.instagram.com/p/CxfviLpSFem/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    category: "illustration",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
     {
    id: 33,
    title: "Vriddhagami",
    date: "Aug 2023",
    image: bc33,
    link: "https://www.instagram.com/p/C55FfqWpK1q/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    category: "typo",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 34,
    title: "Rocky Website",
    date: "Jun 2023",
    image: bc34,
    link: "https://dhanushgopi.github.io/rocky/",
    category: "dev",
    stack:[<Javascript/>,<FigmaLogo/>],
    chip: <Devchip/>,
    },
    {
    id: 35,
    title: "ChatGPT Challenge",
    date: "May 2023",
    image: bc35,
    link: "https://www.instagram.com/p/CuFV4ePBab_/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    category: "branddesign",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 36,
    title: "Rocky UI",
    date: "May 2023",
    image: bc36,
    link: "https://www.instagram.com/p/C55FJalpwC_/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    category: "UX",
    stack:[<Illustrator/>,<FigmaLogo/>],
    chip: <Designchip/>,
    },
    {
    id: 37,
    title: "Waste Paper",
    date: "Mar 2023",
    image: bc37,
    link: "https://www.instagram.com/p/C55FU5_Jvzs/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    category: "branddesign",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 38,
    title: "Valluverse",
    date: "Jan 2023",
    image: bc38,
    link: "https://dhanushgopi.github.io/valluverse/",
    category: "dev",
    stack:[<Illustrator/>,<FigmaLogo/>,<Javascript/>],
    chip: <Devchip/>,
    },
    {
    id: 39,
    title: "Valluverse UI",
    date: "Jan 2023",
    image: bc39,
    link: "https://www.behance.net/gallery/164331693/VALLUVERSE-UI",
    category: "ux",
    stack:[<Illustrator/>,<FigmaLogo/>],
    chip: <Designchip/>,
    },
    {
    id: 40,
    title: "En Nenjil!",
    date: "Dec 2022",
    image: bc40,
    link: "https://www.behance.net/gallery/160038337/En-Nenjil-Thalapathy-Wallpaper",
    category: "illustration",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 41,
    title: "Tears Poster",
    date: "Dec 2022",
    image: bc41,
    link: "https://www.instagram.com/p/ClwfR0RhE4c/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    category: "poster",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
     {
    id: 42,
    title: "Isometric of Madras",
    date: "Nov 2022",
    image: bc42,
    link: "https://www.instagram.com/reel/ClTef5gpmVw/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    category: "illustration",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 43,
    title: "Steal from Artist",
    date: "Nov 2022",
    image: bc43,
    link: "https://www.instagram.com/p/CldaJFaJwSI/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    category: "illustration",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 44,
    title: "Chetaa Chai",
    date: "Aug 2022",
    image: bc44,
    link: "https://www.instagram.com/p/Cg4t-ROv9bS/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    category: "branddesign",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 45,
    title: "Astro Bites",
    date: "Jul 2022",
    image: bc45,
    link: "https://www.instagram.com/p/Cf9J5ebvtjp/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    category: "ux",
    stack:[<FigmaLogo/>,<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 46,
    title: "CalTask",
    date: "Jul 2022",
    image: bc46,
    link: "https://www.behance.net/gallery/148065727/CalTask-Logo-Design-Challenge-by-Daf-Designs",
    category: "branddesign",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 47,
    title: "Lykka Naturals",
    date: "Jul 2022",
    image: bc47,
    link: "https://www.instagram.com/p/C55EybWp9gL/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    category: "branddesign",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 48,
    title: "Politics is a Business",
    date: "Jun 2022",
    image: bc48,
    link: "https://www.behance.net/gallery/147179729/Concept-Art",
    category: "poster",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 49,
    title: "Digital Portrait",
    date: "Jun 2022",
    image: bc49,
    link: "https://www.behance.net/gallery/226781707/Vector-Portraits",
    category: "illustration",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 50,
    title: "Beast TShirt Design",
    date: "Mar 2022",
    image: bc50,
    link: "https://www.behance.net/gallery/147178931/T-shirt-Design-for-ICustoMyzo-BEAST",
    category: "illustration",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 51,
    title: "Carousel Poster",
    date: "Feb 2022",
    image: bc51,
    link: "https://drive.google.com/file/d/1NZTJIjiPYuFAfXYUXvgBpwzvspaERn_B/view?usp=sharing",
    category: "poster",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 52,
    title: "Festivities Poster",
    date: "Feb 2022",
    image: bc52,
    link: "https://drive.google.com/file/d/1NZTJIjiPYuFAfXYUXvgBpwzvspaERn_B/view?usp=sharing",
    category: "poster",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
]

export default blogData;